export default {
  givenName(state) {
    return state.givenName;
  },
  surname(state) {
    return state.surname;
  },
  organization(state) {
    return state.organization;
  },
  status(state) {
    return state.updateStatus;
  }
}